import { Component, OnDestroy, OnInit, PipeTransform, ViewChild } from '@angular/core';
import { CabinetEventService } from "../services/cabinet-event.service"
import { SortInfo } from "../../core/models/sort.mode";
import { FeatureSet } from "../../core/statistics-page-menu/statistics-page-menu.component";
import { Page } from "../../core/models/page.model";
import { DatePipe } from "@angular/common";
import { environment } from "../../../environments/environment";
import { ExportsService } from "../../core/services/exports.service";


class TimeStampPipe extends DatePipe {
  public transform(value): any {
    return super.transform(value, 'long', environment.theme.timezone);
  }
}

@Component({
  selector: 'cintas-cabinet-event-summary',
  templateUrl: './cabinet-event-summary.component.html',
  styleUrls: ['./cabinet-event-summary.component.scss']
})
export class CabinetEventSummaryComponent implements OnInit, OnDestroy {

  @ViewChild('dataTable', { static: true }) table: any;

  features: FeatureSet = {
    export: false
  };

  dataLoading;
  exportLoading = false;
  exportDetailsLoading = false;

  page = new Page();
  sort = new SortInfo();
  pipe: PipeTransform;

  rows = [];

  columns = [
    { name: 'Event Id', prop: 'cuid' },
    { name: 'Event Type', prop: 'event_type' },
    { name: 'User name', prop: 'cabinet_user.username' },
    { name: 'Role', prop: 'cabinet_user.role' },
    // { name: 'Remaining Takeout', prop: 'cabinet_user.remaining_takeout' },
    { name: 'Event TimeStamp', prop: 'event_timestamp'},
    { name: 'Tag ID', prop: 'cabinet_user.tag_id' },
    { name: 'Product', prop: 'product_name' },
    { name: 'Amount', prop: 'quantity' },
    { name: 'Created at', prop: 'created_at' },
  ];

  dataSub;


  constructor(private CabinetEventService: CabinetEventService, private datePipe: DatePipe,
    private exportService: ExportsService) { }

  ngOnInit(): void {
    this.setPage({ offset: 0 });
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    console.log(this.page.pageNumber);
    console.log(pageInfo)
    this.loadEvents();
  }

  onSort(event) {
    this.sort = new SortInfo(event.sorts[0].prop, event.sorts[0].dir);
    this.loadEvents();
  }

  loadUsers(): void {
    this.dataLoading = true;
    this.CabinetEventService.getEventSummary().subscribe(data => {
      console.log("comp")
      console.log(data.cabinetEvents)
      this.rows = data.cabinetEvents;
      console.log("comp2")
      console.log(this.rows)
      // this.page.totalElements = data.totalElements; // Adjust based on your API response
      this.dataLoading = false;
    });
  }

  loadEvents() {
    this.dataLoading = true;
    console.log(this.page.pageNumber + 1, this.sort.column, this.sort.dir)
    this.dataSub = this.CabinetEventService.getEvents(null, null, null, this.page.pageNumber + 1, this.sort.column, this.sort.dir)
      .subscribe((res: any) => {
        this.dataLoading = false;
        // const groupedRows = this.groupItemsByDryerAndTime(res.data);
        console.log(res)
        this.rows = res.data;
        console.log(res.data)
        console.log(this.rows)
        this.page = new Page(res.meta);
        console.log(this.page)
        this.table.bodyComponent.updateOffsetY(this.page.pageNumber);
        this.table.offset = this.page.pageNumber;
      });
  }

  onExportDetails(): void {
    // Handle export details
    console.log('Export details');
  }
  ngOnDestroy(): void {
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }
  }

}
